var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrevent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 18H7C7.55 18 8 17.55 8 17V7C8 6.45 7.55 6 7 6H3C2.45 6 2 6.45 2 7V17C2 17.55 2.45 18 3 18ZM4 8H6V16H4V8Z",
    fill: "black",
    fillOpacity: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18H14C14.55 18 15 17.55 15 17V3C15 2.45 14.55 2 14 2H10C9.45 2 9 2.45 9 3V17C9 17.55 9.45 18 10 18ZM11 4H13V16H11V4Z",
    fill: "black",
    fillOpacity: 0.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 9H17C16.45 9 16 9.45 16 10V17C16 17.55 16.45 18 17 18H21C21.55 18 22 17.55 22 17V10C22 9.45 21.55 9 21 9ZM20 16H18V11H20V16Z",
    fill: "black",
    fillOpacity: 0.75
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22 20H2V22H22V20Z",
    fill: "black",
    fillOpacity: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevent);
export default __webpack_public_path__ + "static/media/Prevent.d0f8a10b4cd65ee58fb7e86824af9ff9.svg";
export { ForwardRef as ReactComponent };